import ConfiguratorButton from './components/ConfiguratorButton'
import React from 'react'

const Customizer: React.FC = () => {
    return <ConfiguratorButton />
}

export default Customizer
